<template>
  <div class="section-scene pageVideo">
    <div class="bg-enter"></div>
    <div class="mask"></div>
    <img :src="static_img_url + 'pic/index/logo.png'" class="main-logo">
    <img :src="static_img_url + 'pic/index/logo1.png'" class="logo-vb100" />
    <div class="play-container" v-show="!playVideo">
      <div class="btn btn-01" @click="playVideo = true">
        <i class="iconfont">&#xe67d;</i>
      </div>
      <div class="tips">
        <p>观看主题影片</p>
        <p>《未来医疗100强》</p>
      </div>
    </div>
    <div class="background" v-if="!playVideo">
      <video
        muted="true"
        playsinline="true"
        loop="true"
        disablepictureinpicture="true"
        width="1920"
        height="1080"
        autoplay="autoplay"
        :src="static_img_url + 'video/short_2_1_batch.mp4'"
      >
      </video>
    </div>
    <div class="video-active" v-if="playVideo">
      <video
        loop="true"
        playsinline="true"
        controls="controls"
        disablepictureinpicture="true"
        width="1920"
        height="1080"
        autoplay="autoplay"
        id="ElVideo"
        :src="static_img_url + 'video/short_batch.mp4'">
      </video>
    </div>
    <!-- 离开背景 -->
    <div class="pageVideo-leave-bg"></div>
  </div>
</template>

<script>
import { anima_mixins } from 'js/anima_mixins.js'
import { timeoutSync } from 'js/common.js'
export default {
  mixins:[anima_mixins],
  data() {
    return {
      static_img_url: process.env.VUE_APP_CDN,
      defaultPage: 1,

      playVideo: false,
    };
  },
  methods: {
    /* 
    *  进入时 downEnter 下滚进入  upEnter 上滚进入
    */
    async downEnter(){
      // console.log('PageVideo:下 我进来了')
      await timeoutSync(() => {
        $('.bg-enter').addClass('bg-enter-end')
      },100)
      await timeoutSync(() => {
        $('.btn').removeClass('btn-01')
      },600)
      this.$emit('setLock', true)
    },
    async upEnter(){
      // console.log('PageVideo:上 我进来了')
      await timeoutSync(() => {
        $('.pageVideo-leave-bg').removeClass('exit-bg')
      },100)
      await timeoutSync(() => {
        this.$emit('setLock', true)
      },800)
    },
    /* 
    *  离开时 downLeave 下滚离开  upLeave 上滚离开
    */
    async downLeave(){
      // console.log('PageVideo:下 我离开了')
      $('.pageVideo-leave-bg').addClass('exit-bg')
      await timeoutSync(() => {
        this.$emit('setActivePage',this.nextPage)
        this.playVideo = false
      },800)
    },
    async upLeave(){
      // console.log('PageVideo:上 我离开了')
      $('.btn').addClass('btn-01')
      await timeoutSync(() => {
        $('.bg-enter').removeClass('bg-enter-end')
      },300)
      await timeoutSync(() => {
        this.$emit('setActivePage',this.nextPage)
        this.playVideo = false
      },300)
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus';
@import '~styles/animation.stylus';

.pageVideo 
  .bg-enter
    position absolute
    z-index 20
    left 50%
    top 50%
    transform translate(-50%,-50%) scale(1.5)
    width 100vw
    height 100vw
    border-radius: 50%
    background linear-gradient(-45deg, rgba(214, 162, 77, 1), rgba(255, 215, 149, 1));
    transition all .3s
  .bg-enter-end
    width 0
    height 0
  .logo-vb100 
    position: absolute;
    height: px2vh(55);
    right: px2vw(80);
    bottom: px2vh(80);
    animation slideInUp .8s ease
  .mask 
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: #000;
    opacity: 0.4;
    z-index: -1;
  .play-container 
    padding: px2vh(60);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #fff;
    z-index 5
    .btn 
      cursor: pointer;
      position: absolute;
      width: px2vh(120);
      height: px2vh(120);
      border-radius: 50%;
      background: linear-gradient(-45deg, rgba(214, 162, 77, 1), rgba(255, 215, 149, 1));
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s;
      i
        transition: all 0.3s;
        opacity 1
        font-size: 30px;
      &:hover
        width: px2vh(130);
        height: px2vh(130);
    .btn-01
      width 0
      height 0
      i
        opacity 0
        font-size: 30px;
      &:hover
        width: 0;
        height: 0;
    .tips 
      font-size: 14px;
      line-height: 22px;
      margin-top: px2vh(250)
      overflow hidden
      >p
        animation slideInUp .8s ease
  .video-active
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      video 
        display block
        position absolute
        left 0
        right 0
        top 0
        bottom 0
        width: 100%
        height 100%
        object-fit: cover
        object-position: 50% 50%
  .pageVideo-leave-bg
    position absolute
    z-index 20
    left 0
    right 0
    top 0
    bottom 0
    background: #1e1e1e
    transition all .8s
    transform translateY(100%)
    &.exit-bg
      transform translateY(0)
</style>